// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"PI","modalContent":"QI","header":"RI","close":"SI"};